import { Fragment, useEffect, useState } from "react";
import "../admin/userlist.css";
import "../admin/orderlist.css";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Modal, Box, Typography } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SellerSidebar from "./SellerSidebar";
import {
  faCartShopping,
  faFilter,
  faPencil,
  faSearch,
  faDashboard,
  faList,
  faShoppingBag,
  faSort,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Drawer from "@mui/material/Drawer";
import { Dropdown } from "react-bootstrap";
import MetaData from "../layouts/MetaData";
import axios from "axios";
import Loader from "../layouts/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default function Sellerannouncements() {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);

      const { data } = await axios.get("/api/v1/seller/announcements", {
        withCredentials: true,
      });

      setAnnouncements(data.announcements);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const [formData, setFormData] = useState({
    type: "",
    subject: "",
    description: "",
    image: null,
    attachmentPdf: null,
  });

  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // ✅ IMAGE PREVIEW
      if (name === "image") {
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.type || !formData.subject) {
        toast.error("Type and Subject are required");
        return;
      }

      toast.success("Announcement submitted for approval");

      const form = new FormData();

      form.append("type", formData.type);
      form.append("subject", formData.subject);
      form.append("description", formData.description);

      if (formData.image) {
        form.append("image", formData.image);
      }

      if (formData.attachmentPdf) {
        form.append("pdf", formData.attachmentPdf);
      }

      await axios.post("/api/v1/admin/announcement", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      // reset form
      setFormData({
        type: "",
        subject: "",
        description: "",
        image: null,
        attachmentPdf: null,
      });

      setIsCreateOpen(false);

      fetchAnnouncements(); // refresh list
    } catch (error) {
      console.error(error);
      toast.error("Failed to create announcement ❌");
    }
  };

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [editId, setEditId] = useState(null);

  const handleEditClick = (item) => {
    setSelectedAnnouncement(item);

    setFormData({
      type: item.type || "",

      subject: item.subject || "",

      mainHeading: item.mainHeading || "",

      mainParagraph: item.mainParagraph || "",

      listHeading: item.listSection?.heading || "",

      listItems:
        item.listSection?.items?.length > 0
          ? item.listSection.items
          : ["", "", "", ""],

      subHeading: item.subSection?.heading || "",

      subParagraphs:
        item.subSection?.paragraphs?.length > 0
          ? item.subSection.paragraphs
          : ["", ""],

      image: null,
      attachmentPdf: null,
    });

    setPreviewImage(item.image || null);

    setEditId(item._id);

    setIsEditOpen(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();

      form.append("type", formData.type);
      form.append("subject", formData.subject);
      form.append("description", formData.description);

      if (formData.image) form.append("image", formData.image);
      if (formData.attachmentPdf) form.append("pdf", formData.attachmentPdf);

      await axios.put(`/api/v1/admin/announcement/${editId}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      toast.success("Announcement Updated successfully");

      setIsEditOpen(false);
      fetchAnnouncements();
    } catch (error) {
      console.error(error);
    }
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // OPEN MODAL
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setDeleteModalOpen(true);
  };

  // CLOSE MODAL
  const cancelDelete = () => {
    setDeleteModalOpen(false);
  };

  // CONFIRM DELETE
  const confirmDelete = async () => {
    try {
      await axios.delete(`/api/v1/admin/announcement/${selectedId}`, {
        withCredentials: true,
      });

      toast.success("Deleted Successfully");

      setDeleteModalOpen(false);
      fetchAnnouncements(); // refresh list
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
    }
  };

  const [previewImage, setPreviewImage] = useState(null);

  // Drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Navbar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <MetaData title="Seller Orders | GLOCRE Private Limited" />
      <section className="seller-order-list-glc">
        <div className="row container-fluid">
          <div className="col-12 col-md-2">
            <SellerSidebar />
          </div>
          <div className="col-12 col-lg-10 col-md-12 pr-0">
            <Link to="/">
              <div className="mobile-logo">
                <img
                  src={require("../../images/procure-g-logo.png")}
                  alt="glocre"
                />
              </div>
            </Link>

            <div className="breadcrumbWrapperr">
              {/* Breadcrumbs & Menu Icon Row (For Mobile) */}
              {isMobile ? (
                <div className="row mobile-topbar">
                  <div className="col-10">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/seller/dashboard" style={{ color: "#fff" }}>
                          Dashboard
                        </Link>
                      </li>
                      <li>Announcements List</li>
                    </ul>
                  </div>
                  <div className="col-2 p-0 d-flex justify-content-center align-items-center">
                    <button className="fab" onClick={toggleDrawer}>
                      <FontAwesomeIcon icon={faList} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row dash-navbar-big-glc small-sticky-navbar">
                  <div className="col-lg-3 col-md-12">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/seller/dashboard">Dashboard</Link>
                      </li>
                      <li>Announcements List</li>
                    </ul>
                  </div>
                  <div className="col-lg-7 col-md-6 d-flex justify-content-end align-items-end">
                    <div className="dash-cont-glc">
                      <div className="row">
                        <div className="topnav">
                          <div className="search-container">
                            <form className="d-flex">
                              <input
                                type="text"
                                placeholder="Search"
                                name="search"
                              />
                              <button type="submit">
                                <FontAwesomeIcon icon={faSearch} />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default"
                        id="dropdown-basic"
                        className="custom-filter-toggle"
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Processing</Dropdown.Item>
                        <Dropdown.Item>Shipped</Dropdown.Item>
                        <Dropdown.Item>Delivered</Dropdown.Item>
                        <Dropdown.Item>All</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Search, Filter & Avatar Row (For Mobile) */}
              {isMobile && (
                <div className="row mobile-bottombar">
                  <div className="col-9 col-md-10 pr-0">
                    <div className="search-container">
                      <form className="d-flex">
                        <input type="text" placeholder="Search" name="search" />
                        <button type="submit">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-3 col-md-2  d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default text-white"
                        id="dropdown-basic"
                        className="text-dark dropdown1 icon-list-filter-procureg"
                        style={{
                          backgroundImage: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Processing</Dropdown.Item>
                        <Dropdown.Item>Shipped</Dropdown.Item>
                        <Dropdown.Item>Delivered</Dropdown.Item>
                        <Dropdown.Item>All</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {/* <div className="col-2 text-center">
                                        <img src={avatar1} alt="Avatar" className="avatar" />
                                    </div> */}
                </div>
              )}

              {/* Drawer Component */}
              <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                direction="right"
                className="drawer"
              >
                <div className="drawer-header">
                  SELLER DASHBOARD
                  {/* <button className="drawer-close-btn" onClick={toggleDrawer}>&times;</button> */}
                </div>
                <div className="drawer-content">
                  <ul className="drawer-links">
                    <li>
                      <Link to="/seller/dashboard">
                        <FontAwesomeIcon icon={faDashboard} /> &nbsp;Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/products">
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp;Product
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/products/create">
                        <FontAwesomeIcon icon={faShoppingBag} /> &nbsp;Create
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/announcements">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Announcements
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/archive/product">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Archive Products
                      </Link>
                    </li>
                  </ul>
                </div>
              </Drawer>
            </div>

            <div className="row">
              <div className="col-md-10">
                <h3
                  className=""
                  style={{ color: "#ffad63", marginTop: "40px" }}
                >
                  ANNOUNCEMENT LIST
                </h3>
              </div>
            </div>

            <section className="orderlist-section-procureg cartWrapper mt-2">
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table">
                  <thead className="">
                    <tr>
                      <th style={{ minWidth: "100px" }}>SI.NO</th>
                      <th style={{ minWidth: "100px" }}>DATE</th>
                      <th style={{ minWidth: "100px" }}>TYPE</th>
                      <th style={{ minWidth: "300px" }}>SUBJECT</th>
                      <th style={{ minWidth: "120px" }}>STATUS</th>
                      <th style={{ minWidth: "100px" }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <Loader />
                        </td>
                      </tr>
                    ) : announcements.length === 0 ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center"
                          style={{ fontSize: "14px" }}
                        >
                          No announcements found
                        </td>
                      </tr>
                    ) : (
                      announcements.map((item) => (
                        <tr key={item._id}>
                          <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.slNo}
                            </span>
                          </td>
                          <td>
                            <span
                              className="cursor"
                              style={{ color: "#8c8c8c" }}
                            >
                              {new Date(item.createdAt).toLocaleDateString()}
                            </span>
                          </td>
                          <td style={{ color: "#ffad63", fontSize: "15px" }}>
                            {item.type}
                          </td>
                          <td>
                            <span
                              style={{ color: "#8c8c8c", fontSize: "15px" }}
                            >
                              {item.subject
                                ? item.subject
                                    .split(" ")
                                    .slice(0, 7)
                                    .join(" ") +
                                  (item.subject.split(" ").length > 10
                                    ? "..."
                                    : "")
                                : ""}
                            </span>
                          </td>
                          <td>
                            <span
                              style={{
                                color:
                                  item.status === "approved"
                                    ? "green"
                                    : item.status === "rejected"
                                      ? "red"
                                      : "#ffad63",
                                fontSize: "15px",
                              }}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "#ffad63",
                                color: "#fff",
                              }}
                              onClick={() => navigate(`/seller/editAnnouncements/${item._id}`)}
                            >
                              <FontAwesomeIcon icon={faPencil} />
                            </button>

                            <button
                              className="btn ms-2"
                              style={{
                                backgroundColor: "#2f4d2a",
                                color: "#fff",
                              }}
                              onClick={() => handleDeleteClick(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <Modal open={deleteModalOpen} onClose={cancelDelete}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      p: 4,
                      borderRadius: 2,
                      width: 300,
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <Typography
                      variant="h6"
                      mb={2}
                      align="center"
                      fontSize={17}
                      color="#8c8c8c"
                    >
                      Are you sure you want to delete this announcement? (It
                      won't be recovered)
                    </Typography>

                    <Box display="flex" justifyContent="space-between">
                      <Button
                        onClick={confirmDelete}
                        sx={{ margin: "3px" }}
                        className="left-but"
                      >
                        Yes
                      </Button>

                      <Button
                        onClick={cancelDelete}
                        sx={{ margin: "3px" }}
                        className="right-but"
                      >
                        No
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </div>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}
